define('modules/Product/ProductPricingService',[
    'jquery',
    'global/Logger',
], function ($, Logger) {
    'use strict';
    var apiUrl = window.RocConfig.api.baseRocApiUrl;

    function getPricing(productId, qty, uom) {
        return $.ajax({
            url: apiUrl + '/api/product/pricing/',
            type: 'POST',
            dataType: 'json',
            contentType: 'application/json',
            data: JSON.stringify([{
                'productId': productId,
                'quantity': qty,
                'uomId': uom
            }])
        });
    }

    var ProductPricingService = {
        getPricing: getPricing
    };

    Logger.debug('ProductPricingService.js Loaded:', ProductPricingService);

    return ProductPricingService;
});
